import InputRoot from './InputRoot'
import SingleError from './components/singleError/SingleError'

export const Input = {
  Root: InputRoot,
  SingleError: SingleError,
}
